import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualConfigurationPageRoutingModule } from './manual-configuration-routing.module';

import { ManualConfigurationPage } from './manual-configuration.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualConfigurationPageRoutingModule
  ],
  declarations: [ManualConfigurationPage],
  exports: [ManualConfigurationPage]
})
export class ManualConfigurationPageModule {}
